(function() {
    'use strict';

    function initSlideshowVideoControls() {
        const videoContainers = document.querySelectorAll('.home-carousel__video.js-home-carousel-video--self');
        
        videoContainers.forEach(container => {
            if (container.dataset.controlsInitialized) return;
            container.dataset.controlsInitialized = 'true';

            const verticalPos = container.dataset.videoControlsVertical || 'bottom';
            const horizontalPos = container.dataset.videoControlsHorizontal || 'left';

            const playButton = document.createElement('button');
            playButton.className = 'home-carousel__video-play-button';
            playButton.type = 'button';
            playButton.setAttribute('aria-label', 'Play video');
            playButton.setAttribute('data-vertical', verticalPos);
            playButton.setAttribute('data-horizontal', horizontalPos);
            playButton.innerHTML = `
                <svg class="play-icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="30" r="30" fill="white"/>
                    <path d="M25 18L43 30L25 42V18Z" fill="#212121"/>
                </svg>
                <svg class="pause-icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: none;">
                    <circle cx="30" cy="30" r="30" fill="white"/>
                    <rect x="22" y="18" width="5" height="24" fill="#212121"/>
                    <rect x="33" y="18" width="5" height="24" fill="#212121"/>
                </svg>
            `;
            container.appendChild(playButton);
            
            requestAnimationFrame(() => {
                playButton.style.willChange = 'opacity, visibility';
            });

            function findVideo() {
                const switcher = container.querySelector('lazy-video-switcher');
                if (switcher) {
                    const visibleLazy = switcher.querySelector('lazy-video:not([hidden])') || 
                                       switcher.querySelector('lazy-video');
                    return visibleLazy?.querySelector('video');
                }
                const lazyVideo = container.querySelector('lazy-video');
                return lazyVideo?.querySelector('video');
            }

            function updateUI() {
                const video = findVideo();
                const isPlaying = video && !video.paused && !video.ended && video.readyState > 2;
                
                const playIcon = playButton.querySelector('.play-icon');
                const pauseIcon = playButton.querySelector('.pause-icon');
                
                if (isPlaying) {
                    container.classList.add('is-playing');
                    playButton.setAttribute('aria-label', 'Pause video');
                    if (playIcon) playIcon.style.display = 'none';
                    if (pauseIcon) pauseIcon.style.display = 'block';
                } else {
                    container.classList.remove('is-playing');
                    playButton.setAttribute('aria-label', 'Play video');
                    if (playIcon) playIcon.style.display = 'block';
                    if (pauseIcon) pauseIcon.style.display = 'none';
                }
            }

            function togglePlayPause() {
                const video = findVideo();
                
                if (!video) {
                    const lazyVideo = container.querySelector('lazy-video');
                    if (lazyVideo && !lazyVideo.hasAttribute('loaded')) {
                        if (typeof lazyVideo.loadContent === 'function') {
                            lazyVideo.loadContent();
                        }
                        setTimeout(() => {
                            const newVideo = findVideo();
                            if (newVideo) {
                                newVideo.play().catch(() => {});
                            }
                        }, 200);
                    }
                    return;
                }

                if (video.paused || video.ended) {
                    video.play().catch(() => {});
                } else {
                    video.pause();
                }
            }

            playButton.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                togglePlayPause();
            });

            function setupVideoListeners(video) {
                if (!video) return;

                const handlePlay = () => updateUI();
                const handlePause = () => updateUI();
                const handleEnded = () => updateUI();
                const handleLoadedData = () => {
                    updateUI();
                    requestAnimationFrame(() => {
                        playButton.classList.add('is-ready');
                    });
                };

                video.removeEventListener('play', handlePlay);
                video.removeEventListener('pause', handlePause);
                video.removeEventListener('ended', handleEnded);
                video.removeEventListener('loadeddata', handleLoadedData);

                video.addEventListener('play', handlePlay);
                video.addEventListener('pause', handlePause);
                video.addEventListener('ended', handleEnded);
                video.addEventListener('loadeddata', handleLoadedData);

                if (video.readyState >= 2) {
                    updateUI();
                    requestAnimationFrame(() => {
                        playButton.classList.add('is-ready');
                    });
                } else {
                    updateUI();
                }
            }

            const observer = new MutationObserver(function() {
                const video = findVideo();
                if (video) {
                    setupVideoListeners(video);
                    const switcher = container.querySelector('lazy-video-switcher');
                    if (switcher) {
                        switcher.querySelectorAll('video').forEach(v => {
                            setupVideoListeners(v);
                        });
                    }
                }
            });

            observer.observe(container, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['loaded', 'hidden']
            });

            updateUI();
            
            updateUI();
            
            let checkAttempts = 0;
            const checkInterval = setInterval(() => {
                checkAttempts++;
                const video = findVideo();
                if (video) {
                    setupVideoListeners(video);
                    clearInterval(checkInterval);
                } else if (checkAttempts > 20) {
                    requestAnimationFrame(() => {
                        playButton.classList.add('is-ready');
                    });
                    clearInterval(checkInterval);
                }
            }, 200);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSlideshowVideoControls);
    } else {
        initSlideshowVideoControls();
    }

    setTimeout(initSlideshowVideoControls, 1000);
})();
